import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable ,  Subject } from 'rxjs';

@Injectable()
export class AlertService {
  private subject = new Subject<any>();
  private keepAfterNavigationChange = false;
  private message;

  constructor(
    private router: Router
  ) {
      // clear alert message on route change
      router.events.subscribe(event => {
          if (event instanceof NavigationStart) {
              if (this.keepAfterNavigationChange) {
                  // only keep for a single location change
                  this.keepAfterNavigationChange = false;
              } else {
                  // clear alert
                  this.subject.next();
              }
          }
      });
  }

  clear() {
    this.subject.next();
  }

  success(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.message = message;
    this.subject.next({ type: 'success', text: this.message });
  }

  successAppend(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.message = this.message + '<br />' + message;
    this.subject.next({ type: 'success', text: this.message });
  }

  error(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.message = message;
    this.subject.next({ type: 'error', text: this.message });
  }
  errorAppend(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.message = this.message + '<br />' + message;
    this.subject.next({ type: 'error', text: this.message });
}

  getMessage(): Observable<any> {
      return this.subject.asObservable();
  }
}
